module.exports = __webpack_public_path__ + "static/logo-3d598a980a09427edcabdbeeb6be87e9.svg";